// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapIcon } from '../../../dsl/front';
import { MarqueeText } from './MarqueeText';
import { newsBarConfig } from './NewsBar.config';
import { NewsBarColor } from './NewsBar.contracts';
/**
 * @emits close - When the "close" button has been clicked.
 *
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let NewsBar = class NewsBar extends Vue {
    constructor() {
        super(...arguments);
        /**
         * Determines whether the `<MarqueeText>'s` animation is paused.
         */
        this.isPaused = false;
        /**
         * Determines whether the `<MarqueeText>` component should be rendered.
         *
         * If the text doesn't overflow its container, there's no need to use the `<MarqueeText>` component;
         * the `<p>` element will do.
         */
        this.showMarquee = false;
    }
    /**
     * Vue's lifecycle hook.
     */
    mounted() {
        this.checkMarquee();
    }
    /**
     * The CSS class that contains the style declarations for the background of the component.
     */
    get bgClass() {
        return newsBarConfig[this.color].bgClass;
    }
    /**
     * Handles `@click` event on the "Close" `<button>`.
     */
    onCloseClick() {
        if (this.closable) {
            this.$emit('close');
        }
    }
    /**
     * Pauses the `<MarqueeText>'s` animation.
     */
    pause() {
        this.isPaused = true;
    }
    /**
     * Plays the `<MarqueeText>'s` animation.
     */
    play() {
        this.isPaused = false;
    }
    /**
     * The CSS class that contains the style declarations for the text elements inside the component.
     */
    get textClass() {
        return newsBarConfig[this.color].textClass;
    }
    /**
     * Checks whether the `<MarqueeText>` should be rendered.
     */
    checkMarquee() {
        if (typeof this.staticTextRef !== 'undefined') {
            // console.log(this.staticTextRef.scrollWidth, this.staticTextRef.clientWidth)
            // this.showMarquee = this.staticTextRef.scrollWidth > this.staticTextRef.clientWidth
            this.showMarquee = this.staticTextRef.scrollWidth > (window.innerWidth * 0.75);
        }
    }
};
__decorate([
    Prop({
        type: String,
        required: false,
        default: NewsBarColor.Brand
    })
], NewsBar.prototype, "color", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    })
], NewsBar.prototype, "closable", void 0);
__decorate([
    Ref('staticText')
], NewsBar.prototype, "staticTextRef", void 0);
NewsBar = __decorate([
    Component({
        name: 'NewsBar',
        components: {
            BootstrapButton,
            BootstrapIcon,
            MarqueeText
        },
        template: `
    <div class="news-bar text-ui-medium text-center"
         :class="[bgClass, textClass, { '--show-marquee': showMarquee }]"
         role="marquee" @mouseenter="pause" @mouseleave="play">
    <!-- Static text -->
    <div class="news-bar__static-text" ref="staticText">
      <slot/>
    </div>

    <!-- Animated text -->
    <MarqueeText v-if="showMarquee" :duration="20" :paused="isPaused" :repeat="4"
                 class="news-bar__marquee">
      <slot/>
    </MarqueeText>

    <!-- "Close" button -->
    <BootstrapButton v-if="closable" class="news-bar__close-btn btn-link p-0" @click="onCloseClick" aria-label="Close the bar">
      <BootstrapIcon name="close" size="small" :class="textClass"/>
    </BootstrapButton>
    </div>
  `
    })
], NewsBar);
export { NewsBar };
